import { createContext } from 'react';
import { QUERY_KEYS_CIHA, useChartsData } from '../../Common/hooks/useChartsData';
import { useCIHAFiltersContext } from '../../Common/Filters/hooks/useCIHAFiltersContext';

export const FinancingChartsDataContext = createContext();

const FinancingChartsDataProvider = ({ children }) => {
    const { filters } = useCIHAFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
        cnes: filters.unidade?.value,
        ano: filters.year?.value || currentYear,
        mes: filters.month?.value
    };

    const bySource = useChartsData(
        {
            key: QUERY_KEYS_CIHA.FINANCING_BY_SOURCE,
            url: 'governanceroom/cihadashboard/financingBySource'
        },
        filterParams
    );

    const sourceByYear = useChartsData(
        {
            key: QUERY_KEYS_CIHA.FINANCING_SOURCE_BY_YEAR,
            url: 'governanceroom/cihadashboard/financingSourceByYear'
        },
        filterParams,
        true
    );

    const byChargingReason = useChartsData(
        {
            key: QUERY_KEYS_CIHA.FINANCING_BY_CHARGING_REASON,
            url: 'governanceroom/cihadashboard/financingByChargingReason'
        },
        filterParams
    );

    const natureBySource = useChartsData(
        {
            key: QUERY_KEYS_CIHA.FINANCING_NATURE_BY_SOURCE,
            url: 'governanceroom/cihadashboard/financingNatureBySource'
        },
        filterParams
    );

    const queries = [bySource, sourceByYear, byChargingReason, natureBySource];
    const isLoading = queries.some((query) => query.isLoading);
    const isError = queries.some((query) => query.isError);

    const chartData = {
        bySource: bySource.data?.por_fonte || [],
        sourceByYear: sourceByYear.data?.fonte_por_ano || {},
        byChargingReason: byChargingReason.data?.por_cobranca || [],
        natureBySource: natureBySource.data?.natureza_por_fonte || {}
    };

    return (
        <FinancingChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters
            }}
        >
            {children}
        </FinancingChartsDataContext.Provider>
    );
};

export default FinancingChartsDataProvider;
